import BackToStreamButton from './BackToStreamButton';
import BackToStreamButtonContainer from './BackToStreamButton.container';
export default BackToStreamButtonContainer(BackToStreamButton);
//# sourceMappingURL=index.js.map